import { createAsyncThunk } from "@reduxjs/toolkit";
import coreAPIs from "services/api/core";

export const getOrCreateFilmstrip = createAsyncThunk(
  "filmstrip/getOrCreateFilmstrip",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await coreAPIs.getOrCreateFilmstrip(payload);

      return response.data;
    } catch (error) {
      console.error(error);

      return rejectWithValue(error.response.data);
    }
  },
);
